module.exports = __webpack_public_path__ + "static/media/turkey-map.0396b8f3.svg";